import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./actions";

const initialState = {
  hasNewMachine: false
};

export const machineSlice = createSlice({
  name: "machine",
  initialState,
  reducers: {
    setHasNewMachine: (state, action) => {
      state.hasNewMachine = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  }
});

export const { setHasNewMachine } = machineSlice.actions;
export default machineSlice.reducer;
